import { atom } from 'jotai';
import { ChanceTime } from '@/functions/types/chanceTime';

export const chanceTimeAtom = atom<ChanceTime>({} as ChanceTime);

chanceTimeAtom.debugLabel = 'chanceTimeAtom';
